import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import parse from "html-react-parser";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { getSalesOrder } from "../../services/sales/salesOrderService";
import { formatDate } from "../../utils/utils";
import NumberFormat from "react-number-format";
import {
  getSharedDocuments,
  uploadSharedDocument,
} from "../../services/commons";
import DialogLayout from "./DialogLayout";
import { DialogActions } from "@material-ui/core";
import { CustomOutlinedDisabledTextField } from "./Forms";
import copy from "clipboard-copy";
import BootstrapTooltip from "./BootstrapTooltip";
import Swal from "sweetalert2";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
const CustomPrintOutSalesOrder = ({
  title = "SALES ORDER",
  salesOrderID = 0,
  currentDateTime = DateTime.now(),
}) => {
  const { companyProfile, reload } = useGlobalData();
  const [salesOrder, setSalesOrder] = useState({
    ID: 0,
    salesOrderCode: "",
    customer: { customerName: "" },
    currency: { currencyCode: "" },
    salesOrderItem: [],
    soBillingAddress: { address: "" },
    soDeliveryAddress: { address: "" },
    note: "",
    toc: "",
  });
  const [openSharedDocument, setOpenSharedDocument] = useState(false);
  const [sharedDocumentLink, setSharedDocumentLink] = useState("");
  const timestamp = DateTime.now().toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [isCopySucceed, setIsCopySucceed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    getSalesOrderData(salesOrderID);
    setFrom(companyProfile.companyName);
    setWhatsappNumber(salesOrder.customer.addressPhone);
    getSharedDocumentData("SORD", salesOrder.ID);
  }, [reload]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "@page { size: ledger; !important; } @media print { body { -webkit-print-color-adjust: exact; !important; } }",
    documentTitle: `Sales Order_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}`,
  });
  const handleDownloadPDF = () => {
    var opt = {
      margin: 0,
      filename: `Sales Order_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .save();
  };
  const handleSharePDF = () => {
    let fileName = `Sales Order_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}.pdf`;
    let fileNameConverted = fileName.replace(/ /g, "").replace(/:/g, "");
    var opt = {
      margin: 0,
      filename: `Sales Order_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .output("datauristring")
      .then(function(pdf) {
        const filesData = new FormData();
        const preBlob = dataURItoBlob(pdf);
        const file = new File([preBlob], fileNameConverted, {
          type: "application/pdf",
        });
        filesData.append("files[]", file);
        filesData.append("docID", salesOrder.ID);
        filesData.append("docType", "SORD");
        uploadSharedDocument(filesData).then((response) => {
          getSharedDocumentData("SORD", salesOrder.ID);
          setOpenSharedDocument(true);
        });
      });
  };

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  return (
    <React.Fragment>
      <div className="row justify-content-center py-2 px-5 py-md-2 px-md-0">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-label-success btn-md btn-pill btn-bold"
              onClick={handleDownloadPDF}
            >
              <i className="fas fa-cloud-download-alt"></i>
              Download Sales Order
            </button>
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold"
              onClick={handleSharePDF}
            >
              <i className="fas fa-share-alt"></i>
              Share Sales Order
            </button>
            <button
              type="button"
              className="btn btn-label-info btn-md btn-pill btn-bold"
              onClick={handlePrint}
            >
              <i className="fas fa-print"></i>
              Print Sales Order
            </button>
          </div>
        </div>
      </div>
      <div ref={componentRef} className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom overflow-hidden border-0">
            <div className="card-body p-0">
              <div className="row justify-content-center pt-5 pb-3 px-5 pt-md-5 pb-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <h1 className="display-5 kt-font-bolder text-dark mb-3 mr-1">
                      {title}
                    </h1>
                    <div className="d-flex flex-column align-items-md-end px-0 ml-1">
                      <div className="mb-3">
                        <Image
                          src={
                            companyProfile.companyProfileLogo.length > 0
                              ? companyProfile.companyProfileLogo[0].imagePath.includes(
                                  "?"
                                )
                                ? `${companyProfile.companyProfileLogo[0].imagePath}&v=${timestamp}`
                                : `${companyProfile.companyProfileLogo[0].imagePath}?v=${timestamp}`
                              : "/media/logos/logo-form-header.png"
                          }
                          style={{
                            maxHeight: "9rem",
                            maxWidth: "18rem",
                          }}
                          alt="Company Profile Logo"
                          fluid
                          crossOrigin="anonymous"
                        />
                      </div>
                      <div
                        className="d-flex flex-column align-items-md-end text-wrap"
                        style={{
                          maxWidth: "300px",
                        }}
                      >
                        <Typography className="kt-font-bolder text-dark text-md-right text-uppercase">
                          {companyProfile.companyName}
                        </Typography>
                        <Typography className="kt-font-bold text-muted text-md-right">
                          {companyProfile.fullAddress}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between">
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        SALES ORDER NO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {salesOrder.salesOrderCode}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        SALES ORDER DATE.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {formatDate(salesOrder.orderDate)}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        EXPECTED DELIVERY DATE.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {formatDate(salesOrder.expDeliveryDate)}
                      </Typography>
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        BILL TO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        <strong>{salesOrder.customer.customerName}</strong>
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        {salesOrder.soBillingAddress.fullAddress}
                      </Typography>
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        SHIP TO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        <strong>{salesOrder.customer.customerName}</strong>
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        {salesOrder.soDeliveryAddress.fullAddress}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th style={{ width: "25%" }} className="pl-0">
                            <Typography className="kt-font-bolder text-muted">
                              ITEM NAME
                            </Typography>
                          </th>
                          <th style={{ width: "15%" }}>
                            <Typography className="kt-font-bolder text-muted">
                              QTY
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }}>
                            <Typography className="text-right kt-font-bolder text-muted">
                              UNIT PRICE
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }}>
                            <Typography className="text-right kt-font-bolder text-muted">
                              ITEM DISCOUNT
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }} className="pr-0">
                            <Typography className="text-right kt-font-bolder text-muted">
                              TOTAL PRICE
                            </Typography>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {salesOrder.salesOrderItem &&
                        salesOrder.salesOrderItem.length > 0 ? (
                          <React.Fragment>
                            {salesOrder.salesOrderItem.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr className="kt-font-bolder border-bottom-0">
                                    <td className="pl-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.itemCode} {item.itemName}
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.qty} {item.uomName}
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.unitPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {salesOrder.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.discountAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {salesOrder.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td className="pr-0 py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.totalPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {salesOrder.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ) : null}
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography className="text-right kt-font-bolder text-muted">
                              SUB TOTAL
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={salesOrder.subTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {salesOrder.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography
                              component="div"
                              className="text-right kt-font-bolder text-muted"
                            >
                              <NumberFormat
                                value={salesOrder.discountPercent}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div>
                                    DISCOUNT{" ("}
                                    {value}
                                    {"%)"}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={salesOrder.discountAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    - {salesOrder.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography
                              component="div"
                              className="text-right kt-font-bolder text-muted"
                            >
                              <NumberFormat
                                value={salesOrder.taxPercent}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div>
                                    TAX{" ("}
                                    {value}
                                    {"%)"}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={salesOrder.taxAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {salesOrder.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography className="text-right kt-font-bolder text-muted">
                              ADDITIONAL COST
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={salesOrder.addCostTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {salesOrder.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <div className="d-flex flex-column mb-3 mb-md-0 mr-1">
                      <div className="kt-font-bolder text-muted mb-2">
                        <Typography className="kt-font-bolder text-muted">
                          NOTES OR SPECIAL INSTRUCTIONS.
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-dark">
                        {salesOrder.note ? (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            {parse(salesOrder.note)}
                          </Typography>
                        ) : (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            -
                          </Typography>
                        )}
                      </div>
                      <div className="kt-font-bolder text-muted mt-3 mb-2">
                        <Typography className="kt-font-bolder text-muted">
                          TERMS AND CONDITIONS.
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-dark">
                        {salesOrder.toc ? (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            {parse(salesOrder.toc)}
                          </Typography>
                        ) : (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            -
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-column text-md-right ml-1">
                      <Typography
                        variant="h6"
                        className="kt-font-bolder text-muted mb-1"
                      >
                        GRAND TOTAL
                      </Typography>
                      <Typography
                        variant="h5"
                        component="div"
                        className="kt-font-bolder text-dark mb-1"
                      >
                        <NumberFormat
                          value={salesOrder.grandTotal}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">
                              {salesOrder.currencyCode} {value}
                            </div>
                          )}
                        />
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-1">
                        {salesOrder.taxAmount > 0
                          ? "Taxes Included"
                          : "Taxes Not Included"}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center pt-3 pb-5 px-5 pt-md-3 pb-md-5 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          If you have any questions about this Sales Order,
                          please contact{" "}
                          <strong>{companyProfile.companyName}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          <strong>{companyProfile.fullAddress}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Tel: <strong>{companyProfile.phone}</strong>, Email:{" "}
                          <strong>{companyProfile.email}</strong>, Website:{" "}
                          <strong>{companyProfile.website}</strong>
                        </Typography>
                      </div>
                    </div>
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Thank you for your business!
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-center">
                        <Typography className="kt-font-bold text-center">
                          <i>
                            This is a computer-generated document. No signature
                            is required.
                          </i>
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSharedDocument}
        title={"Shared Document Link"}
        onCloseDialog={() => {
          setOpenSharedDocument(false);
        }}
        //fullScreen={false}
        maxWIdth="sm"
      >
        <React.Fragment>
          <CustomOutlinedDisabledTextField
            label="Shared Document URL Link"
            value={sharedDocumentLink}
          />
        </React.Fragment>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSharedDocument(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={(e) => {
              e.preventDefault();
              let message = sharedDocumentLink;
              if (whatsappNumber === "") {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Customer Whatsapp Number cannot be empty",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              } else {
                // Regex expression to remove all characters which are NOT alphanumeric
                let number = whatsappNumber
                  .replace(/[^\w\s]/gi, "")
                  .replace(/ /g, "");

                // Appending the phone number to the URL
                let url = `https://web.whatsapp.com/send?phone=${number}`;

                // Appending the message to the URL by encoding it
                url += `&text=${encodeURI(message)}&app_absent=0`;

                // Open our newly created URL in a new tab to send the message
                window.open(url);
              }
            }}
          >
            <i className="flaticon-whatsapp"></i>
            Send To Whatsapp
          </button>
          <BootstrapTooltip
            title="URL Copied"
            open={isCopySucceed}
            onClose={() => {
              setIsCopySucceed(false);
            }}
          >
            <button
              type="button"
              className="btn btn-dark btn-md btn-pill btn-bold"
              onClick={() => {
                copy(sharedDocumentLink).then(() => {
                  setIsCopySucceed(true);
                });
              }}
            >
              <i className="fas fa-copy"></i>
              Copy To Clipboard
            </button>
          </BootstrapTooltip>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getSalesOrderData(salesOrderID) {
    if (salesOrderID > 0) {
      const response = await getSalesOrder(salesOrderID);
      const { data } = response.data;
      setSalesOrder(data.salesOrder);
      setTo(data.salesOrder.customer.customerName);
    }
  }

  async function getSharedDocumentData(docType, docID) {
    const response = await getSharedDocuments(docType, docID);
    const { data } = response.data;
    let sharedDocuments = data.sharedDocuments;
    if (sharedDocuments.length > 0) {
      setSharedDocumentLink(sharedDocuments[0].filePath);
    }
  }
};

export default CustomPrintOutSalesOrder;
